import styled from 'styled-components/macro';
import { defaultContainer } from '../../styles/utils';

export const PartnersWrapperDiv = styled.div`
  ${defaultContainer};
  /* > h5 {
    margin-top: 60px;
    margin-bottom: 23px;
  } */
`;

export const PartnersHeaderBlock = styled.div`
  padding-top: 5rem;
  @media screen and (max-width: 767px) {
    margin-left: -2rem;
    p {
      padding-left: 2rem;
    }
  }
  margin-bottom: 4rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 5.5rem;
  }
`;

export const PartnersH4 = styled.h4`
  padding-bottom: 1rem;
`;
